import React from 'react';
import {
  SectionContainer,
  LeftContainer,
  RightContainer,
  ContentWrapper,
  LogoContainer,
  Title,
  Description
} from './styles';
import logoImage from '../../../assets/images/logo.png';

const SolutionsSection = () => {
  return (
    <SectionContainer>
      <LeftContainer>
        <ContentWrapper>
          <LogoContainer>
            <img src={logoImage} alt="Floqss" />
          </LogoContainer>

          <Title>Floqss rompe barreras y abre puertas.</Title>

          <Description>
            ¿No tienes tarjeta? ¿Te da miedo pagar por internet? Floqss fue creada para ti.
            Ahora puedes comprar cursos, libros y mentorías digitales sin pagar por adelantado. Sin riesgos. Sin compartir datos bancarios.
            Una forma nueva, segura y real de acceder al mundo digital.
          </Description>
        </ContentWrapper>
      </LeftContainer>
      <RightContainer />
    </SectionContainer>
  );
};

export default SolutionsSection;